import apiClient from '@/services/axios'

export async function get(venueSetupId) {

  var params = { 'venue-setup-id': venueSetupId }
  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/products', { params: params });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get venue setup products')
}
